// IMPORTANT: After modifying this file, update CHANGELOG.md with a summary of your changes.
// Add clear comments for non-obvious changes, including what replaced prior behavior, to avoid repeating failed fixes.

"use client";

import { useState, useEffect } from "react";

export function RotatingProblems({ problems }: { problems: string[] }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (problems.length <= 1) return;
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % problems.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [problems.length]);

  // Grid stacking keeps the height constant across rotations. Every phrase is
  // rendered into the SAME grid cell (col-start-1 row-start-1), so the grid
  // sizes itself to the tallest (most-wrapped) phrase. Inactive phrases stay
  // `invisible` — they still reserve their height but aren't shown. This
  // replaces the old single-line container, which jumped taller whenever a
  // long phrase wrapped to two lines and the next one didn't.
  return (
    <span className="grid">
      {problems.map((problem, i) => (
        <span
          key={i}
          aria-hidden={i !== index}
          className={`col-start-1 row-start-1 text-opichi-red font-bold transition-opacity duration-300 ${
            i === index ? "opacity-100" : "opacity-0 invisible"
          }`}
        >
          {problem}
        </span>
      ))}
    </span>
  );
}
